import styled, { css } from "styled-components";
import { WrapperContainer } from "../../../../components";

const FileUploadWrapperNewStyles = css`
  height: 90px;
  padding-top: 8px;
  align-items: start;
`;

export const FileUploadWrapper = styled(WrapperContainer)`
  ${(props) => props?.isNewRow && FileUploadWrapperNewStyles}
`;

export const FileUploadErrorWrapper = styled(WrapperContainer)`
  width: 20px;
  height: 20px;

  svg {
    width: 20px;
    height: 20px;
  }
`;
